import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WizardOption } from 'src/app/models/wizard/wizard-option';
import { WizardStep } from 'src/app/models/wizard/wizard-step';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { WizardStepName } from 'src/app/services/wizard/wizard-step-name.enum';
import { WizardService} from 'src/app/services/wizard/wizard.service';

@Component({
  selector: 'app-brand-filters',
  templateUrl: './brand-filters.component.html',
  styleUrls: ['./brand-filters.component.scss']
})
export class BrandFiltersComponent implements OnInit {

  @Output() setInitialSelectedBrands: EventEmitter<string[]> = new EventEmitter();
  @Output() brandsToFilterBy: EventEmitter<string[]> = new EventEmitter();

  title: string = "";
  brands: string[] = [];
  selectedBrands: string[] = [];

  constructor(
    private wizardService: WizardService,
    private confSvc: ConfigService,
    private analytics: AnalyticsService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("brandsFilterTitle");

    this.setBrands();
    this.setSelectedBrands({});
  }

  setBrands(): void {
    const brandsToDisplay = this.confSvc.getStringArray("brandsOptionsToDisplay").slice();
    // brandsToDisplay.push(this.confSvc.getString("aOpenDisplayName"));
    this.brands = brandsToDisplay.sort((a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'}));
  }

  setSelectedBrands(e: any): void {
    this.wizardService.getSelectedWizardOptionsForStepAndWatch(WizardStepName.Brands)
      .subscribe(options => {
        this.selectedBrands = options.filter(option => option.title !== this.confSvc.getString("brandNoPreferenceOptionTitle")).map(option => option.title);
        this.setInitialSelectedBrands.emit(this.selectedBrands);
      });
  }

  brandIsSelected(brand: string): boolean {
    return this.selectedBrands.some(b => b === brand);
  }

  onBrandFilterChange(brand: string, isEventFromFilterChips: boolean = false): void {
    const indexOfSelectedBrand = this.selectedBrands.indexOf(brand);
    let isInList = this.selectedBrands.includes(brand)
    if(isInList || isEventFromFilterChips){
      this.wizardService.removeSelectedWizardOption(brand);
      this.selectedBrands = this.selectedBrands.filter(b => b != brand)
    }else {
      let newStep = new WizardStep()
      newStep.name = 4;
      let option: WizardOption = {
        title: brand,
        subtitle: brand,
        imgSrc: "",
        iconFontSet: "",
        iconName: "",
        iconSvgName: "",
        isSelected: false,
        step: newStep,
        tooltipText: "",
        isSingleOption: false,
      };
      this.wizardService.addSelectedWizardOption(option);
      this.selectedBrands.push(brand);
    }
    this.brandsToFilterBy.emit(this.selectedBrands);
    this.analytics.logCheckboxFilterClick(AnalyticsUtility.filterType.brand, brand, indexOfSelectedBrand < 0);
  }

}
